import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import CardNav from './components/CardNav';
import Hero from './components/Hero';
import WhyUs from './components/WhyUs';
import Services from './components/Services';
import Brands from './components/Brands';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Stats from './components/Stats';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import logo from './images/whiteicon.png';

// Navigation items for CardNav
const navItems = [
  {
    label: "Services",
    bgColor: "#1a0f2b",
    textColor: "#fff",
    links: [
      { label: "Media Buying", ariaLabel: "Meta and Google Ads Management", href: "#services" },
      { label: "Social Media Management", ariaLabel: "Social Media Content & Strategy", href: "#services" },
      { label: "Photography and Video", ariaLabel: "Professional Content Creation", href: "#services" },
      { label: "User Generated Content", ariaLabel: "UGC Campaigns", href: "#services" }
    ]
  },
  {
    label: "About", 
    bgColor: "#B37BA4",
    textColor: "#fff",
    links: [
      { label: "About Us", ariaLabel: "Learn About Hunter Digital", href: "/about-us" },
      { label: "Testimonials", ariaLabel: "Client Success Stories", href: "#testimonials" },
      { label: "About the Founder", ariaLabel: "Meet Our Founder", href: "#about" }
    ]
  },
  {
    label: "Contact",
    bgColor: "#D99AC5", 
    textColor: "#fff",
    links: [
      { label: "Facebook", ariaLabel: "Follow us on Facebook", href: "https://www.facebook.com/HunterDigitalMarketingSolutions" },
      { label: "Instagram", ariaLabel: "Follow us on Instagram", href: "https://www.instagram.com/hunterdigital_/" },
      { label: "LinkedIn", ariaLabel: "Connect with us on LinkedIn", href: "https://www.linkedin.com/company/hunter-digital-marketing-solutions" }
    ]
  }
];

// Home page component with all sections
const HomePage = () => (
  <>
    <CardNav
      logo={logo}
      logoAlt="Hunter Digital Philippines Logo"
      items={navItems}
      baseColor="rgba(255, 255, 255, 0.95)"
      menuColor="#1f2937"
      buttonBgColor="#B37BA4"
      buttonTextColor="#fff"
      ease="power3.out"
    />
    <div className="card-nav-offset" aria-hidden="true" />
    <main>
      <Hero />
      <WhyUs />
      <Services />
      <Brands />
      <Testimonials />
      <About />
      <Stats />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home page with all sections */}
          <Route path="/" element={<HomePage />} />
          
          {/* Separate About Us page */}
          <Route path="/about-us" element={
            <>
              <CardNav
                logo={logo}
                logoAlt="Hunter Digital Philippines Logo"
                items={navItems}
                baseColor="rgba(255, 255, 255, 0.95)"
                menuColor="#1f2937"
                buttonBgColor="#B37BA4"
                buttonTextColor="#fff"
                ease="power3.out"
              />
              <div className="card-nav-offset" aria-hidden="true" />
              <AboutUs />
              <Footer />
            </>
          } />
          
          {/* Add other separate pages here if needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;